import React from 'react'
import { Input, Select, SelectContent, SelectTrigger, SelectItem } from '@shopflo/ui'
import {
  CouponType,
  DiscountApplyToType,
  EntitledCatalogueSelectionMode,
  UiConfigDiscountType
} from 'src/lib/types/discountsV2'
import { useDiscountForm } from '../../../hooks/useDiscountForm'
import FreebieSelectorProductsList from './FreebieSelectorProductsList'
import FormErrorText from 'src/components/common/FormErrorText'

const FreebieSelectorEntitlement = () => {
  const {
    state: { entitlement, uiConfig, errors },
    actions: { setFormState }
  } = useDiscountForm()

  if (entitlement.type !== CouponType.BXGY) return null
  if (uiConfig.type !== UiConfigDiscountType.FREEBIE_SELECTOR) return null

  const { applyTo } = entitlement as any
  const firstGroupQuantityError = errors['entitlement.entitledCatalogue.0.quantity']

  const handleTargetChange = (value: string) => {
    let applyTo = DiscountApplyToType.SPECIFIC_PRODUCTS

    if (value === 'specific_products') {
      applyTo = DiscountApplyToType.SPECIFIC_PRODUCTS
    } else if (value === 'specific_collections') {
      applyTo = DiscountApplyToType.SPECIFIC_COLLECTIONS
    }

    setFormState({
      entitlement: {
        ...entitlement,
        applyTo,
        entitledCatalogue: [
          {
            quantity: 1,
            entities: [],
            selectionMode: EntitledCatalogueSelectionMode.ANY
          }
        ],
        excludedCatalogue: [],
        metaData: {
          ...entitlement.metaData,
          entitledCatalogue: [],
          excludedCatalogue: []
        }
      }
    })
  }

  const handleQuantityChange = (val: string) => {
    const quantity = parseInt(val) || 0
    const newEntitledCatalogue = [...entitlement.entitledCatalogue]

    if (newEntitledCatalogue.length === 1) {
      newEntitledCatalogue[0] = {
        ...newEntitledCatalogue[0],
        quantity
      }
    }

    setFormState({
      entitlement: {
        ...entitlement,
        entitledProductCount: quantity,
        entitledCatalogue: newEntitledCatalogue
      }
    })
  }

  const handleBlur = () => {
    if (entitlement.entitledProductCount === 0) {
      handleQuantityChange('1')
    }
  }

  return (
    <div className='flex flex-col w-full gap-3 pb-6'>
      <h3 className='text-text-sm-semibold'>Reward</h3>
      <div className='flex flex-col gap-1'>
        <div className='flex gap-3 w-full '>
          <div className='flex-1'>
            <Input
              value={entitlement.entitledProductCount > 0 ? entitlement.entitledProductCount.toString() : ''}
              onChange={e => handleQuantityChange(e.target.value)}
              onBlur={e => handleBlur()}
              placeholder='2'
              type='number'
              dimension='md'
              disabled={entitlement.entitledCatalogue.length > 1}
              className='data-[disabled=true]:!opacity-100 '
              endAdornment={<span className='text-zinc-400 text-sm whitespace-nowrap'>free items</span>}
            />
          </div>

          <div className='flex-1'>
            <Select
              value={
                applyTo === DiscountApplyToType.SPECIFIC_COLLECTIONS ? 'specific_collections' : 'specific_products'
              }
              onValueChange={handleTargetChange}
            >
              <SelectTrigger
                className='w-full h-9 bg-white rounded-lg opacity-100 text-zinc-800 border-zinc-200'
                showCaret
              >
                <div className='p-1 truncate'>
                  {applyTo === DiscountApplyToType.SPECIFIC_COLLECTIONS
                    ? 'from selected collections'
                    : 'from selected products'}
                </div>
              </SelectTrigger>
              <SelectContent>
                <SelectItem value='specific_products'>from selected products</SelectItem>
                <SelectItem value='specific_collections'>from selected collections</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        {entitlement.entitledCatalogue.length > 1 && firstGroupQuantityError && (
          <FormErrorText message={firstGroupQuantityError} />
        )}
      </div>

      {(applyTo === DiscountApplyToType.SPECIFIC_PRODUCTS || applyTo === DiscountApplyToType.SPECIFIC_COLLECTIONS) && (
        <FreebieSelectorProductsList />
      )}
    </div>
  )
}

export default FreebieSelectorEntitlement
